import SectionLabel from "@/components/base/SectionLabel";
import { aiOfficeData } from "@/mocks/aiOfficeData";

export default function AboutSection() {
  return (
    <section id="about-section" className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={aiOfficeData.about.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {aiOfficeData.about.title}
          </h2>
          <div className="space-y-3">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aiOfficeData.about.description}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aiOfficeData.about.description2}
            </p>
          </div>
        </div>

        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-7">
            <div className="flex items-center gap-2.5 mb-4 md:mb-5">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-user-received-line text-secondary-600" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {aiOfficeData.about.agencySide.title}
              </h3>
            </div>
            <ul className="space-y-2.5 md:space-y-3">
              {aiOfficeData.about.agencySide.points.map((p, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-foreground-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 mt-1.5 flex-shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-primary-50/60 border border-primary-200/60 p-6 md:p-7">
            <div className="flex items-center gap-2.5 mb-4 md:mb-5">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-team-line text-background-50" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {aiOfficeData.about.nobleSide.title}
              </h3>
            </div>
            <ul className="space-y-2.5 md:space-y-3">
              {aiOfficeData.about.nobleSide.points.map((p, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-foreground-700">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-1.5 flex-shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}